import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import { http } from "../helper";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_settings";

const SessionSettings = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [isChecked, setIsChecked] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_settings")
  ) {
    window.location.href = "/unauthorized";
  }

  const btnsubmit = () => {
    const element = document.getElementById("clear_session_btn");
    element.classList.add("loader-btn");
    setShowPopup(true);
  };

  const sessionclear = () => {
    let payload = {
      clearsession: isChecked ? 1 : 0,
    };
    let URL = BaseUrl + "admin/deletesessions";
    http
      .delete(URL, payload)
      .then(async (response) => {
        if (response.data.success === true) {
          const element = document.getElementById("clear_session_btn");
          element.classList.remove("loader-btn");
          setShowPopup(false);
          setAlertPopup(true);
          setAlertMessage(
            t("session_deleted_successfully_txt")
          );
        }
      })
      .catch((err) => {
        const element = document.getElementById("clear_session_btn");
        element.classList.remove("loader-btn");
        console.log(err);
      });
  };

  const closePopup = () => {
    const element = document.getElementById("clear_session_btn");
    element.classList.remove("loader-btn");
    setShowPopup(false);
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <CommonAlert
          title={t("alert_txt")}
          message={alertMessage}
          onClose={() => setAlertPopup(false)}
        />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("delete_sessions_txt")}</h1>
            <div className="right-table-outer-wrap">
              <div className="form-field">
                <div className="input-field col-1">
                  <button
                    title={t("delete_sessions_txt")}
                    className="clear-session"
                    id="clear_session_btn"
                    onClick={btnsubmit}
                    disabled={isReadOnly}
                  >
                    {t("delete_sessions_txt")}
                  </button>
                  <p className="text-note">
                    {t("delete_sessions_description_txt")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
      {showPopup && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("delete_customer_sessions_confirmation_txt")}</p>
                <div className="alert-buttons">
                  <button
                    title={t("ok_txt")}
                    onClick={sessionclear}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </button>
                  <button
                    title={t("cancel_txt")}
                    onClick={closePopup}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default SessionSettings;
